webpackJsonp([114276838955818,60335399758886],{

/***/ 109:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(210);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(109);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "contact" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { method: "post", name: "contact", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	                    _react2.default.createElement(
	                        "p",
	                        { className: "hidden-form" },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "Don\u2019t fill this out if you're human: ",
	                            _react2.default.createElement("input", { name: "bot-field" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half first" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "name" },
	                            "Nom"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "name", id: "name" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "email" },
	                            "Email"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "email", id: "email" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "message" },
	                            "Message"
	                        ),
	                        _react2.default.createElement("textarea", { name: "message", id: "message", rows: "6" })
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "actions" },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "button",
	                                { className: "special" },
	                                "Envoyer"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "reset", value: "Effacer" })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: "split" },
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-button" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: "https://www.clicrdv.com/233-cabinet-garnier?clicrdv_widget=1&widget_width=600&websource=https%3A%2F%2Fwww.reflexologie-olonne.fr%2Fcontact.html" },
	                            _react2.default.createElement(
	                                "button",
	                                null,
	                                "prendre RDV maintenant"
	                            ),
	                            " "
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-phone" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "T\xE9l\xE9phone"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "06.84.89.60.82"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-home" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Adresse"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "La Greni\xE8re",
	                            _react2.default.createElement("br", null),
	                            "Aubigny ",
	                            _react2.default.createElement("br", null),
	                            "85430 Aubigny-les Clouzeaux",
	                            _react2.default.createElement("br", null)
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { href: "https://www.google.com/maps/place/Anne+GARNIER+R%C3%A9flexologue/@46.5311371,-1.7714428,11z/data=!4m8!1m2!2m1!1sanne+garnier!3m4!1s0x0:0x8bf6281c58a33a1f!8m2!3d46.5694825!4d-1.4665461" },
	                            "Google Maps"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "p",
	                { className: "siret" },
	                "Num\xE9ro de siret : 834 187 981 00016"
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "copyright" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "\xA9 Vincent Bourdeau - 2018"
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo' },
	            _react2.default.createElement(
	                'strong',
	                null,
	                'anne garnier'
	            ),
	            ' ',
	            _react2.default.createElement(
	                'span',
	                null,
	                'r\xE9flexologie'
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'menu-link', onClick: props.onToggleMenu, href: 'javascript:;' },
	                'Menu'
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	    return _react2.default.createElement(
	        'nav',
	        { id: 'menu' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        'Home'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/qui' },
	                        'Qui suis-je?'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/reflexologie' },
	                        'La r\xE9flexologie'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/bienfaits' },
	                        'Les bienfaits'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/prestations' },
	                        'Prestations'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/infos' },
	                        'Infos / Actus'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://fr-fr.facebook.com/annegarnier.reflexologue/' },
	                        'Facebook'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	            'Close'
	        )
	    );
	};
	
	Menu.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	__webpack_require__(350);
	
	var _Header = __webpack_require__(208);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(209);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Contact = __webpack_require__(206);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Footer = __webpack_require__(207);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('link', { rel: 'stylesheet', href: (0, _gatsbyLink.withPrefix)('skel.css') })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	                children(),
	                _react2.default.createElement(_Contact2.default, null),
	                _react2.default.createElement(_Footer2.default, null)
	            ),
	            _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b2041f0e0d5973b7ed76.js